import { Component, EventEmitter, OnInit } from '@angular/core';
import {
  UntypedFormControl,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import {
  HeaderFilters,
  HttpService,
  LocalStorageService,
  MenuBreadCrumb,
  MessageService,
  params,
  SessionService,
  TableColumns,
  TableConfiguration,
} from 'brainloper-ui';
import { GeneratePdfFosilService } from 'src/app/services/generate-pdf-fosil.service';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { DeleteGenericService } from 'src/app/services/delete-generic.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { WorkOrderService } from 'src/app/services/work-order.service';
import { WorkOrder } from 'src/app/models/maintenance/work-order';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Provider } from 'src/app/models/administration/provider';
import { CommentService } from 'src/app/services/comment.service';
import { modulesByRol } from '@edgarzon93/brainloper-shared';

export enum stateTab {
  TABLE = 0,
  DETAIL = 1,
  CLOSEOT = 2,
}

@Component({
    selector: 'app-maintenance-orders-execution',
    templateUrl: './maintenance-orders-execution.component.html',
    styleUrls: ['./maintenance-orders-execution.component.scss'],
    standalone: false
})
export class MaintenanceOrdersExecutionComponent implements OnInit {
  private urlWorkOrden: string = `${EndpointDictionary.WorkOrder.CRUD_WORK_ORDER_DATA}`;  
  private urlComboEquipo: string = `${EndpointDictionary.Equipment.EQUIPMENT_COMBO}`;
  private urlComboUsuarios: string = `${EndpointDictionary.User.USER_COMBO}`;
  public urlTablaOT: string = `${EndpointDictionary.WorkOrder.WORK_ORDER_TABLE}`;

  public selected = new UntypedFormControl(0);  
  public detailsClickRow: WorkOrder;
  public currentState: stateTab = stateTab.TABLE;
  public bodyOrden: WorkOrder;
  public orderId: number;
  public stateTab = stateTab;

  public params: params[] = [
    { id: 'equipmentId', value: '0' },
    { id: 'active', value: '1' },
    { id: 'authorized', value: '1' },
    { id: 'readyResources', value: '1' },
  ];
  private paramsUsuariosOrdenes: params[] = [
    { id: 'page', value: '0' },
    { id: 'per_page', value: '12' },
    { id: 'filter', value: '' },
    { id: 'orderId', value: '0' },
  ];
  public roleId:number

  //tabla ordenes de trabajo
  public recargarTablaOT = new EventEmitter<any>();
  public dataOT: WorkOrder[] = [];
  public configurationOT: TableConfiguration = {
    edit: true,
    add: true,
    editPer: true,
    addPer: true,
    selectable: false,
    primaryKey: 'id',
    print: true,
    closeOrder: true,
    sendEmail: true,
    addComment: true,
    view: true,
  };

  public columnasOT: TableColumns<WorkOrder>[] = [
    {
      ID: 'consecutive',
      label: '#',
      type: 'text',
      style: {
        textAlign: 'center',
        width: '80px',
        movil: 'no-movil',
      },
    },
    {
      ID: 'code',
      label: 'Código',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'equipmentBrand',
      label: 'Marca',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'component',
      label: 'Componente',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'responsible',
      label: 'Responsable',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'description',
      label: 'Descripción',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'maintenanceType',
      label: 'Tipo Mtto',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'executionDate',
      label: 'Fecha',
      type: 'fecha',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'invoiceReference',
      label: 'Ref. Factura',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'maintenanceProvider',
      label: 'Proveedor',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
        width: '20%',
      },
    },
  ];

  headerFilters: Array<HeaderFilters> = [
    {
      tN: 'equipos',
      labelFilter: 'Equipo',
      urlData: this.urlComboEquipo,
      visibleField: 'code',
      primaryKey: 'id',
      type: 'select',
      value: '',
    },
    {
      tN: 'ordenes_trabajo',
      labelFilter: 'Responsable',
      urlData: this.urlComboUsuarios,
      visibleField: 'name',
      primaryKey: 'userId',
      type: 'select',
      value: '',
      fileNameDb: 'responsable',
    },
    {
      tN: 'ordenes_trabajo',
      labelFilter: 'Fecha Ejecución',
      visibleField: 'fecha_ejecucion',
      type: 'date',
      value: '',
    },
    {
      tN: 'ordenes_trabajo',
      labelFilter: 'Fecha Ejecución Entre',
      visibleField: 'fecha_ejecucion',
      type: 'dateRange',
      value: '',
    },
  ];

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: 'Inicio',
      router: '/inicio',
    },
    {
      name: 'Ejecución OT',
      current: true,
    },
  ];

  constructor(
    public dialog: MatDialog,
    private session: SessionService,
    private message: MessageService,
    private http: HttpService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private generatePdf: GeneratePdfFosilService,
    private deleteItem: DeleteGenericService,
    private storage: LocalStorageService,
    private notificationService: NotificationsService,
    private workOrderService: WorkOrderService,
    private commentService: CommentService,
  ) {   
      this.roleId = this.storage.get<number>('roleId')
  }

  ngOnInit(): void {
  }

  agregarOT($event) {
    //console.log($event)
    this.session.setData('data', { action: 'add' });
    this.router.navigate(['/mantenimiento/orden_trabajo/detalle']);
  }

  async clickFilaOT($event: WorkOrder[]) {
    this.message.openLoading('Cargando', 'Cargando informacion');
    //console.log($event)
    this.orderId = $event[0].id;

    for (let element of this.paramsUsuariosOrdenes) {
      if (element.id == 'orderId') {
        element.value = $event[0].id;
      }
    }
    this.selected.setValue(1);
    this.currentState = stateTab.CLOSEOT;
    this.message.closeLoading();
  }

  
  back($event: MatTabChangeEvent) {
    switch ($event.index) {
      case 0:
        this.selected.setValue(0);
        break;
      case 1:
        this.selected.setValue(1);
        break;
      default:
        break;
    }

    //console.log($event)
  }
  
  async editarOT($event: WorkOrder[]) {
    let res: boolean = await this.workOrderService.editOT($event[0].id);
    if (res) {
      this.router.navigate(['detalle'], { relativeTo: this.activeRoute });
    }
  }

  async eliminarOT($event: Array<WorkOrder>) {
    let res = await this.deleteItem.deleteD($event, this.urlWorkOrden, 'id');
    if (res) {
      let urlNotifications: Array<string> = [];
      for (const i of $event) {
        urlNotifications.push(
          `notificaciones/ejecucion?id_orden_trabajo=${i.id}`
        );
      }
      this.notificationService.deleteNotificationsByUrl(urlNotifications);
      this.message.SuccessToast('Notificación eliminada correctamente');
      this.recargarTablaOT.emit();
    } else {
      this.recargarTablaOT.emit();
    }
  }

  async print($event: WorkOrder[]) {
    this.message.openLoading('Cargando', 'Generando PDF');
    await this.generatePdf.printTemplateOt($event[0].id);
    this.message.closeLoading();
  }

  async sendEmail($event: WorkOrder[]) {
    const maintenanceProvider = $event[0]?.maintenanceProvider;

    if (!maintenanceProvider || maintenanceProvider === 'Mantenimiento interno') {
      this.message.Info(
        'No es posible enviar correo',
        'Esta orden no tiene asociado un proveedor.'
      );
      return;
    }

    const userConfirmed = await this.message.Info(
      'Confirmación de envío de correo',
      '',
      true
    );
    if (!userConfirmed) return;

    try {
      this.message.openLoading('Cargando', 'Enviando correo');

      const emailData: Provider[] | undefined = await this.http.postDataBody(
        `${EndpointDictionary.WorkOrder.POST_EMAIL}`,
        $event[0]
      );

      if (!emailData || emailData.length === 0) {
        this.message.Info(
          'No es posible enviar correo',
            !emailData
              ? 'Error al obtener correos del proveedor.'
              : 'El correo del proveedor no es válido.'
        );
        return;
      }

      const emailList = emailData
        .map(d => `[${d.providerName} - ${d.email}]`)
        .join('\n');

      this.message.Success(
        '¡Correo enviado con éxito!',
        emailData.length === 1
          ? 'El correo se envió correctamente a:\n' + emailList
          : 'Los correos se enviaron correctamente a:\n' + emailList
      );
    } catch (error) {
      this.message.Error('Error', 'No se pudo enviar el correo.');
    } finally {
      this.message.closeLoading();
    }
  }

  getBodyOrder() {
   
  }

  addCommentService($event: WorkOrder[]) {
    this.commentService.addComment($event[0].id)
  }

   viewDetailService($event: WorkOrder[]) {
    this.detailsClickRow = $event[0];
    this.selected.setValue(1);
    this.currentState = stateTab.DETAIL;
  }
}
